var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sid-select w-full px-[16px]"},[_c('div',{staticClass:"flex items-center gap-x-2 my-2"},[_c('b-checkbox',{staticClass:"mt-0",attrs:{"switch":""},model:{value:(_vm.element.options.content.paymentSummary.showCoupon),callback:function ($$v) {_vm.$set(_vm.element.options.content.paymentSummary, "showCoupon", $$v)},expression:"element.options.content.paymentSummary.showCoupon"}}),_c('label',{staticClass:"text-sm text-[#6E747A] pb-0"},[_vm._v("Enable Coupons")])],1),_c('Sidbear-settings-group',{style:({margin: '0 -16px'}),attrs:{"title":"Summary Title","button-class":"!px-[16px]","content-class":"!py-[14px] !px-[16px]"}},[_c('sid-font',{attrs:{"sid":`.payment-summary-title.--${_vm.element.sid}--title`}}),_c('sid-range-slider',{attrs:{"label":"Font Size","sid":`.payment-summary-title.--${_vm.element.sid}--title`,"default-dimension":"px","px-range":[0, 300],"rule-name":"font-size"}}),_c('sid-range-slider',{attrs:{"label":"Letter-Spacing","sid":`.payment-summary-title.--${_vm.element.sid}--title`,"rule-name":"letter-spacing","min":-2,"dimensions":[]}}),_c('sid-range-slider',{attrs:{"label":"Line-Height","sid":`.payment-summary-title.--${_vm.element.sid}--title`,"rule-name":"line-height","default-dimension":'',"min":0,"max":5,"step":.1,"var":"--line-height","dimensions":[]}}),_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between"},[_c('label',{staticClass:"pb-0"},[_vm._v("Text Color")]),_c('sid-color',{attrs:{"sid":`.payment-summary-title.--${_vm.element.sid}--title`,"rule-name":"color"}})],1)])],1),_c('Sidbear-settings-group',{style:({margin: '0 -16px'}),attrs:{"title":"Product Title","button-class":"!px-[16px]","content-class":"!py-[14px] !px-[16px]"}},[_c('sid-font',{attrs:{"sid":`.payment-summary-product.--${_vm.element.sid}--product`}}),_c('sid-range-slider',{attrs:{"label":"Font Size","sid":`.payment-summary-product.--${_vm.element.sid}--product`,"default-dimension":"px","px-range":[0, 300],"rule-name":"font-size"}}),_c('sid-range-slider',{attrs:{"label":"Letter-Spacing","sid":`.payment-summary-product.--${_vm.element.sid}--product`,"rule-name":"letter-spacing","min":-2,"dimensions":[]}}),_c('sid-range-slider',{attrs:{"label":"Line-Height","sid":`.payment-summary-product.--${_vm.element.sid}--product`,"rule-name":"line-height","default-dimension":'',"min":0,"max":5,"step":.1,"var":"--line-height","dimensions":[]}}),_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between"},[_c('label',{staticClass:"pb-0"},[_vm._v("Text Color")]),_c('sid-color',{attrs:{"sid":`.payment-summary-product.--${_vm.element.sid}--product`,"rule-name":"color"}})],1)])],1),_c('Sidbear-settings-group',{style:({margin: '0 -16px'}),attrs:{"title":"Product Price","button-class":"!px-[16px]","content-class":"!py-[14px] !px-[16px]"}},[_c('sid-font',{attrs:{"sid":`.payment-summary-price.--${_vm.element.sid}--price`}}),_c('sid-range-slider',{attrs:{"label":"Font Size","sid":`.payment-summary-price.--${_vm.element.sid}--price`,"default-dimension":"px","px-range":[0, 300],"rule-name":"font-size"}}),_c('sid-range-slider',{attrs:{"label":"Letter-Spacing","sid":`.payment-summary-price.--${_vm.element.sid}--price`,"rule-name":"letter-spacing","min":-2,"dimensions":[]}}),_c('sid-range-slider',{attrs:{"label":"Line-Height","sid":`.payment-summary-price.--${_vm.element.sid}--price`,"rule-name":"line-height","default-dimension":'',"min":0,"max":5,"step":.1,"var":"--line-height","dimensions":[]}}),_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between"},[_c('label',{staticClass:"pb-0"},[_vm._v("Text Color")]),_c('sid-color',{attrs:{"sid":`.payment-summary-price.--${_vm.element.sid}--price`,"rule-name":"color"}})],1)])],1),_c('Sidbear-settings-group',{style:({margin: '0 -16px'}),attrs:{"title":"Coupon Field","button-class":"!px-[16px]","content-class":"!py-[14px] !px-[16px]"}},[_c('sid-range-slider',{staticClass:"mt-[12px]",attrs:{"label":"Width","sid":`.--${_vm.element.sid}--coupon-field`,"dimensions":['%', 'px'],"default-dimension":"%","rule-name":"width","var":"--width","measurement":"width"}}),_c('sid-font',{attrs:{"prefix":"Placeholder","sid":`.--${_vm.element.sid}--coupon-field.input.form-control::placeholder`}}),_c('sid-range-slider',{attrs:{"label":"Placeholder Font Size","sid":`.--${_vm.element.sid}--coupon-field.input.form-control::placeholder`,"rule-name":"font-size"}}),_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between"},[_c('label',{staticClass:"pb-0"},[_vm._v("Placeholder Font Color")]),_c('sid-color',{attrs:{"sid":`.--${_vm.element.sid}--coupon-field.input.form-control::placeholder`,"rule-name":"color"}})],1)]),_c('hr'),_c('sid-font',{attrs:{"prefix":"Field","sid":`.--${_vm.element.sid}--coupon-field.input.form-control`}}),_c('sid-range-slider',{attrs:{"label":"Field Font Size","sid":`.--${_vm.element.sid}--coupon-field.input.form-control`,"rule-name":"font-size"}}),_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between"},[_c('label',{staticClass:"pb-0"},[_vm._v("Field Text Color")]),_c('sid-color',{attrs:{"sid":`.--${_vm.element.sid}--coupon-field.input.form-control`,"rule-name":"color"}})],1)]),_c('rule-tabs',{scopedSlots:_vm._u([{key:"Normal",fn:function(){return [_c('b-form-group',[_c('sid-background',{attrs:{"sid":`.--${_vm.element.sid}--coupon-field.input.form-control`,"small":""}})],1),_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between !gap-[20px]"},[_c('label',{staticClass:"w-full pb-0"},[_vm._v("Border Type")]),_c('sid-select',{attrs:{"sid":`.--${_vm.element.sid}--coupon-field.input.form-control`,"rule-name":"border-style","searchable":false,"options":[
                {
                  label: 'Solid',
                  value: 'solid'
                },
                {
                  label: 'Dashed',
                  value: 'dashed'
                },
                {
                  label: 'Dotted',
                  value: 'dotted'
                },
                {
                  label: 'Double',
                  value: 'double'
                },
                {
                  label: 'Outset',
                  value: 'outset'
                }
              ]}})],1)]),_c('b-form-group',[_c('sid-linked-group',{staticClass:"!mb-[7px]",attrs:{"sid":`.--${_vm.element.sid}--coupon-field.input.form-control`,"label":"Border Width","rule-name":"border","angles":[
              {
                text: '',
                value: 'top-width'
              },
              {
                text: '',
                value: 'right-width'
              },
              {
                text: '',
                value: 'bottom-width'
              },
              {
                text: '',
                value: 'left-width'
              }
            ]}}),_c('div',{staticClass:"flex w-full justify-end"},[_c('sid-color',{attrs:{"sid":`.--${_vm.element.sid}--coupon-field.input.form-control`,"rule-name":"border-color"}})],1)],1),_c('sid-linked-group',{attrs:{"label":"Radius","sid":`.--${_vm.element.sid}--coupon-field.input.form-control`,"rule-name":"border","titles":['top-l', 'top-r', 'bottom-l', 'bottom-r'],"angles":[
            {
              text: '',
              value: 'top-left-radius',
              cssVar: '--border-top-left-radius'
            },
            {
              text: '',
              value: 'top-right-radius',
              cssVar: '--border-top-right-radius'
            },
            {
              text: '',
              value: 'bottom-left-radius',
              cssVar: '--border-bottom-left-radius'
            },
            {
              text: '',
              value: 'bottom-right-radius',
              cssVar: '--border-bottom-right-radius'
            }
          ]}})]},proxy:true},{key:"Hover",fn:function(){return [_c('b-form-group',[_c('sid-background',{attrs:{"sid":`.--${_vm.element.sid}--coupon-field.input.form-control`,"presudo":":hover","small":""}})],1),_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between"},[_c('label',{staticClass:"pb-0"},[_vm._v("Border Type")]),_c('sid-select',{staticClass:"w-[118px]",attrs:{"sid":`.--${_vm.element.sid}--coupon-field.input.form-control`,"rule-name":"border-style","searchable":false,"presudo":":hover","options":[
                {
                  label: 'Solid',
                  value: 'solid'
                },
                {
                  label: 'Dashed',
                  value: 'dashed'
                },
                {
                  label: 'Dotted',
                  value: 'dotted'
                },
                {
                  label: 'Double',
                  value: 'double'
                },
                {
                  label: 'Outset',
                  value: 'outset'
                }
              ]}})],1)]),_c('b-form-group',[_c('sid-linked-group',{staticClass:"!mb-[7px]",attrs:{"sid":`.--${_vm.element.sid}--coupon-field.input.form-control`,"label":"Border Width","rule-name":"border","presudo":":hover","angles":[
              {
                text: '',
                value: 'top-width'
              },
              {
                text: '',
                value: 'right-width'
              },
              {
                text: '',
                value: 'bottom-width'
              },
              {
                text: '',
                value: 'left-width'
              }
            ]}}),_c('div',{staticClass:"flex w-full justify-end"},[_c('sid-color',{attrs:{"sid":`.--${_vm.element.sid}--coupon-field.input.form-control`,"rule-name":"border-color","presudo":":hover"}})],1)],1),_c('sid-linked-group',{attrs:{"label":"Radius","sid":`.--${_vm.element.sid}--coupon-field.input.form-control`,"rule-name":"border","presudo":":hover","titles":['top-l', 'top-r', 'bottom-l', 'bottom-r'],"angles":[
            {
              text: '',
              value: 'top-left-radius',
              cssVar: '--border-top-left-radius'
            },
            {
              text: '',
              value: 'top-right-radius',
              cssVar: '--border-top-right-radius'
            },
            {
              text: '',
              value: 'bottom-left-radius',
              cssVar: '--border-bottom-left-radius'
            },
            {
              text: '',
              value: 'bottom-right-radius',
              cssVar: '--border-bottom-right-radius'
            }
          ]}})]},proxy:true}])}),_c('sid-linked-group',{attrs:{"label":"Padding","sid":`.--${_vm.element.sid}--coupon-field.input.form-control`,"rule-name":"padding","min":0,"angles":[
        {
          text: '',
          value: 'top'
        },
        {
          text: '',
          value: 'right'
        },
        {
          text: '',
          value: 'bottom'
        },
        {
          text: '',
          value: 'left'
        }
      ]}})],1),_c('Sidbear-settings-group',{style:({margin: '0 -16px'}),attrs:{"title":"Coupon Comment","button-class":"!px-[16px]","content-class":"!py-[14px] !px-[16px]"}},[_c('sid-font',{attrs:{"sid":`.--${_vm.element.sid}--coupon-comment`}}),_c('sid-range-slider',{attrs:{"label":"Font Size","sid":`.--${_vm.element.sid}--coupon-comment`,"default-dimension":"px","px-range":[0, 300],"rule-name":"font-size"}}),_c('sid-range-slider',{attrs:{"label":"Letter-Spacing","sid":`.--${_vm.element.sid}--coupon-comment`,"rule-name":"letter-spacing","min":-2,"dimensions":[]}}),_c('sid-range-slider',{attrs:{"label":"Line-Height","sid":`.--${_vm.element.sid}--coupon-comment`,"rule-name":"line-height","default-dimension":'',"min":0,"max":5,"step":.1,"var":"--line-height","dimensions":[]}}),_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between"},[_c('label',{staticClass:"pb-0"},[_vm._v("Text Color")]),_c('sid-color',{attrs:{"sid":`.--${_vm.element.sid}--coupon-comment`,"rule-name":"color"}})],1)])],1),_c('SidbearSettingsGroup',{style:({margin: '0 -16px'}),attrs:{"title":"Coupon Button","button-class":"!px-[16px]","content-class":"!py-[14px] !px-[16px]"}},[_c('rule-tabs',{scopedSlots:_vm._u([{key:"Normal",fn:function(){return [_c('b-form-group',{staticClass:"mb-0"},[_c('sid-background',{attrs:{"sid":`.--${_vm.element.sid}--coupon-button`,"small":""}})],1),_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between"},[_c('label',{staticClass:"pb-0"},[_vm._v("Text Color")]),_c('sid-color',{attrs:{"sid":`.--${_vm.element.sid}--coupon-button`,"rule-name":"color"}})],1)]),_c('sid-font',{attrs:{"sid":`.--${_vm.element.sid}--coupon-button`}}),_c('sid-range-slider',{attrs:{"label":"Font Size","sid":`.--${_vm.element.sid}--coupon-button`,"default-dimension":"px","px-range":[0, 300],"rule-name":"font-size"}}),_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between !gap-[20px]"},[_c('label',{staticClass:"w-full pb-0"},[_vm._v("Border Type")]),_c('sid-select',{attrs:{"sid":`.--${_vm.element.sid}--coupon-button`,"rule-name":"border-style","searchable":false,"options":[
                {
                  label: 'Solid',
                  value: 'solid'
                },
                {
                  label: 'Dashed',
                  value: 'dashed'
                },
                {
                  label: 'Dotted',
                  value: 'dotted'
                },
                {
                  label: 'Double',
                  value: 'double'
                },
                {
                  label: 'Outset',
                  value: 'outset'
                }
              ]}})],1)]),_c('b-form-group',[_c('sid-linked-group',{staticClass:"!mb-[7px]",attrs:{"sid":`.--${_vm.element.sid}--coupon-button`,"label":"Border Width","rule-name":"border","angles":[
              {
                text: '',
                value: 'top-width'
              },
              {
                text: '',
                value: 'right-width'
              },
              {
                text: '',
                value: 'bottom-width'
              },
              {
                text: '',
                value: 'left-width'
              }
            ]}}),_c('div',{staticClass:"flex w-full justify-end"},[_c('sid-color',{attrs:{"sid":`.--${_vm.element.sid}--coupon-button`,"rule-name":"border-color"}})],1)],1),_c('sid-linked-group',{attrs:{"label":"Radius","sid":`.--${_vm.element.sid}--coupon-button`,"rule-name":"border","titles":['top-l', 'top-r', 'bottom-l', 'bottom-r'],"angles":[
            {
              text: '',
              value: 'top-left-radius',
              cssVar: '--border-top-left-radius'
            },
            {
              text: '',
              value: 'top-right-radius',
              cssVar: '--border-top-right-radius'
            },
            {
              text: '',
              value: 'bottom-left-radius',
              cssVar: '--border-bottom-left-radius'
            },
            {
              text: '',
              value: 'bottom-right-radius',
              cssVar: '--border-bottom-right-radius'
            }
          ]}})]},proxy:true},{key:"Hover",fn:function(){return [_c('b-form-group',{staticClass:"mb-0"},[_c('sid-background',{attrs:{"sid":`.--${_vm.element.sid}--coupon-button`,"presudo":":hover","small":""}})],1),_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between"},[_c('label',{staticClass:"pb-0"},[_vm._v("Text Color")]),_c('sid-color',{attrs:{"sid":`.--${_vm.element.sid}--coupon-button`,"rule-name":"color","presudo":":hover"}})],1)]),_c('sid-font',{attrs:{"sid":`.--${_vm.element.sid}--coupon-button`}}),_c('sid-range-slider',{attrs:{"label":"Font Size","sid":`.--${_vm.element.sid}--coupon-button`,"default-dimension":"px","px-range":[0, 300],"rule-name":"font-size","presudo":":hover"}}),_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between !gap-[20px]"},[_c('label',{staticClass:"w-full pb-0"},[_vm._v("Border Type")]),_c('sid-select',{attrs:{"sid":`.--${_vm.element.sid}--coupon-button`,"rule-name":"border-style","searchable":false,"presudo":":hover","options":[
                {
                  label: 'Solid',
                  value: 'solid'
                },
                {
                  label: 'Dashed',
                  value: 'dashed'
                },
                {
                  label: 'Dotted',
                  value: 'dotted'
                },
                {
                  label: 'Double',
                  value: 'double'
                },
                {
                  label: 'Outset',
                  value: 'outset'
                }
              ]}})],1)]),_c('b-form-group',[_c('sid-linked-group',{staticClass:"!mb-[7px]",attrs:{"sid":`.--${_vm.element.sid}--coupon-button`,"label":"Border Width","rule-name":"border","presudo":":hover","angles":[
              {
                text: '',
                value: 'top-width'
              },
              {
                text: '',
                value: 'right-width'
              },
              {
                text: '',
                value: 'bottom-width'
              },
              {
                text: '',
                value: 'left-width'
              }
            ]}}),_c('div',{staticClass:"flex w-full justify-end"},[_c('sid-color',{attrs:{"sid":`.--${_vm.element.sid}--coupon-button`,"rule-name":"border-color","presudo":":hover"}})],1)],1),_c('sid-linked-group',{attrs:{"label":"Radius","sid":`.--${_vm.element.sid}--coupon-button`,"rule-name":"border","presudo":":hover","titles":['top-l', 'top-r', 'bottom-l', 'bottom-r'],"angles":[
            {
              text: '',
              value: 'top-left-radius',
              cssVar: '--border-top-left-radius'
            },
            {
              text: '',
              value: 'top-right-radius',
              cssVar: '--border-top-right-radius'
            },
            {
              text: '',
              value: 'bottom-left-radius',
              cssVar: '--border-bottom-left-radius'
            },
            {
              text: '',
              value: 'bottom-right-radius',
              cssVar: '--border-bottom-right-radius'
            }
          ]}})]},proxy:true}])}),_c('sid-linked-group',{attrs:{"label":"Padding","sid":`.--${_vm.element.sid}--coupon-button`,"rule-name":"padding","min":0,"angles":[
        {
          text: '',
          value: 'top'
        },
        {
          text: '',
          value: 'right'
        },
        {
          text: '',
          value: 'bottom'
        },
        {
          text: '',
          value: 'left'
        }
      ]}})],1),_c('SidbearSettingsGroup',{style:({margin: '0 -16px'}),attrs:{"title":"Background","button-class":"!px-[16px]","content-class":"!py-[14px] !px-[16px]"}},[_c('rule-tabs',{scopedSlots:_vm._u([{key:"Normal",fn:function(){return [_c('b-form-group',[_c('sid-background',{attrs:{"sid":`.--${_vm.element.sid}--margin`,"small":""}})],1)]},proxy:true},{key:"Hover",fn:function(){return [_c('b-form-group',[_c('sid-background',{attrs:{"sid":`.--${_vm.element.sid}--margin`,"presudo":":hover","small":""}})],1)]},proxy:true}])})],1),_c('SidbearSettingsGroup',{style:({margin: '0 -16px'}),attrs:{"title":"Border & Radius","button-class":"!px-[16px]","content-class":"!py-[14px] !px-[16px]"}},[_c('rule-tabs',{scopedSlots:_vm._u([{key:"Normal",fn:function(){return [_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between !gap-[20px]"},[_c('label',{staticClass:"w-full pb-0"},[_vm._v("Border Type")]),_c('sid-select',{attrs:{"sid":`.--${_vm.element.sid}--margin`,"rule-name":"border-style","searchable":false,"options":[
                {
                  label: 'Solid',
                  value: 'solid'
                },
                {
                  label: 'Dashed',
                  value: 'dashed'
                },
                {
                  label: 'Dotted',
                  value: 'dotted'
                },
                {
                  label: 'Double',
                  value: 'double'
                },
                {
                  label: 'Outset',
                  value: 'outset'
                }
              ]}})],1)]),_c('b-form-group',[_c('sid-linked-group',{staticClass:"!mb-[7px]",attrs:{"sid":`.--${_vm.element.sid}--margin`,"label":"Border Width","rule-name":"border","angles":[
              {
                text: '',
                value: 'top-width'
              },
              {
                text: '',
                value: 'right-width'
              },
              {
                text: '',
                value: 'bottom-width'
              },
              {
                text: '',
                value: 'left-width'
              }
            ]}}),_c('div',{staticClass:"flex w-full justify-end"},[_c('sid-color',{attrs:{"sid":`.--${_vm.element.sid}--margin`,"rule-name":"border-color"}})],1)],1),_c('sid-linked-group',{attrs:{"label":"Radius","sid":`.--${_vm.element.sid}--margin`,"rule-name":"border","titles":['top-l', 'top-r', 'bottom-l', 'bottom-r'],"angles":[
            {
              text: '',
              value: 'top-left-radius',
              cssVar: '--border-top-left-radius'
            },
            {
              text: '',
              value: 'top-right-radius',
              cssVar: '--border-top-right-radius'
            },
            {
              text: '',
              value: 'bottom-left-radius',
              cssVar: '--border-bottom-left-radius'
            },
            {
              text: '',
              value: 'bottom-right-radius',
              cssVar: '--border-bottom-right-radius'
            }
          ]}})]},proxy:true},{key:"Hover",fn:function(){return [_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between"},[_c('label',{staticClass:"pb-0"},[_vm._v("Border Type")]),_c('sid-select',{staticClass:"w-[118px]",attrs:{"sid":`.--${_vm.element.sid}--margin`,"rule-name":"border-style","searchable":false,"presudo":":hover","options":[
                {
                  label: 'Solid',
                  value: 'solid'
                },
                {
                  label: 'Dashed',
                  value: 'dashed'
                },
                {
                  label: 'Dotted',
                  value: 'dotted'
                },
                {
                  label: 'Double',
                  value: 'double'
                },
                {
                  label: 'Outset',
                  value: 'outset'
                }
              ]}})],1)]),_c('b-form-group',[_c('sid-linked-group',{staticClass:"!mb-[7px]",attrs:{"sid":`.--${_vm.element.sid}--margin`,"label":"Border Width","rule-name":"border","presudo":":hover","angles":[
              {
                text: '',
                value: 'top-width'
              },
              {
                text: '',
                value: 'right-width'
              },
              {
                text: '',
                value: 'bottom-width'
              },
              {
                text: '',
                value: 'left-width'
              }
            ]}}),_c('div',{staticClass:"flex w-full justify-end"},[_c('sid-color',{attrs:{"sid":`.--${_vm.element.sid}--margin`,"rule-name":"border-color","presudo":":hover"}})],1)],1),_c('sid-linked-group',{attrs:{"label":"Radius","sid":`.--${_vm.element.sid}--margin`,"rule-name":"border","presudo":":hover","titles":['top-l', 'top-r', 'bottom-l', 'bottom-r'],"angles":[
            {
              text: '',
              value: 'top-left-radius',
              cssVar: '--border-top-left-radius'
            },
            {
              text: '',
              value: 'top-right-radius',
              cssVar: '--border-top-right-radius'
            },
            {
              text: '',
              value: 'bottom-left-radius',
              cssVar: '--border-bottom-left-radius'
            },
            {
              text: '',
              value: 'bottom-right-radius',
              cssVar: '--border-bottom-right-radius'
            }
          ]}})]},proxy:true}])})],1),_c('SidbearSettingsGroup',{style:({margin: '0 -16px'}),attrs:{"title":"Padding & Margins","button-class":"!px-[16px]","content-class":"!py-[14px] !px-[16px]"}},[_c('sid-linked-group',{attrs:{"label":"Padding","sid":`.--${_vm.element.sid}--container`,"rule-name":"padding","min":0,"angles":[
        {
          text: '',
          value: 'top'
        },
        {
          text: '',
          value: 'right'
        },
        {
          text: '',
          value: 'bottom'
        },
        {
          text: '',
          value: 'left'
        }
      ]}}),_c('sid-linked-group',{attrs:{"label":"Margin","sid":`.--${_vm.element.sid}--margin`,"rule-name":"margin","min":-2000,"max":2000,"angles":[
        {
          text: '',
          value: 'top'
        },
        {
          text: '',
          value: 'right'
        },
        {
          text: '',
          value: 'bottom'
        },
        {
          text: '',
          value: 'left'
        }
      ]}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }